'use strict';

angular.module('ntmApp').factory('DailyPlanResourcePool', ['$q', 'DailyPlanService', 'DailyPlanResourcePoolFilter', 'Utils', 'DailyPlanConfirmationService', 'FlashService', 'CommonHelper',
    function ($q, DailyPlanService, DailyPlanResourcePoolFilter, Utils, DailyPlanConfirmationService, FlashService, CommonHelper) {

        function DailyPlanResourcePool(context) {

            var self = this;
            var unitStaff = null;
            var allUnitStaff = null;

            self.selectedUnit = context.TopBar.BreadCrumbs.selectedViewType;

            self.tabs = [
                {
                    id: 0,
                    name: context.TopBar.BreadCrumbs.selectedLocation.name,
                    active: true,
                    msg: 'No primary staff found'
                },
                {
                    id: 1,
                    name: 'Others in {0}'.format(context.TopBar.BreadCrumbs.selectedViewType.unitName),
                    active: false,
                    msg: 'No other staff found in unit'
                },
                {
                    id: 2,
                    active: false,
                    cluetip: "Staff must be borrowed from this unit to be usable in the current unit on the left. Once borrowed, they will also appear under the current unit's resource pool for this day with the borrow icon: <i class='fa fa-user-plus margin-left-5' aria-hidden='true' style='color: #f9cb9c;'></i>",
                    msg: 'No staff found in this unit'
                },
            ];

            self.load = function () {

                var deferred = $q.defer();

                self.loadAllUnitStaff();

                var request = context.getViewModeAndSelectedDate();
                request.unitId = context.TopBar.BreadCrumbs.selectedViewType.id || null;

                self.resourcePoolChanging = true;
                DailyPlanService.GetResourcePool(request).then(function (result) {

                    if (result.success) {
                        unitStaff = result.data.staff;
                        proccesUnitStaff();

                        self.filteredStaffAreChanging = true;

                        self.Filter.load().then(function () {
                            self.performFiltering();

                            self.filteredStaffAreChanging = false;
                        });

                        self.initialized = true;
                    }

                    deferred.resolve();

                    self.resourcePoolChanging = false;
                });

                return deferred.promise;
            };

            self.loadAllUnitStaff = function () {

                if (self.selectedUnit.id === context.TopBar.BreadCrumbs.selectedViewType.id) {
                    var activeTab = self.tabs.filter(function (tab) { return tab.active; })[0];
                    if (!activeTab || activeTab.id === 2) {
                        self.toggleRSTabs(self.tabs[0]);
                    }
                    return;
                }

                var request = context.getViewModeAndSelectedDate();
                request.unitId = context.TopBar.BreadCrumbs.selectedViewType.id || null;
                request.filterUnitId = self.selectedUnit.id || null;

                self.resourcePoolChanging = true;

                DailyPlanService.GetResourcePool(request).then(function (result) {

                    if (result.success) {
                        allUnitStaff = result.data.staff;
                        proccesAllUnitStaff();

                        self.tabs[2].name = 'All of {0}'.format(self.selectedUnit.unitName);

                        self.Filter.load().then(function () {
                            self.performFiltering();
                        });

                        self.toggleRSTabs(self.tabs[2]);

                        self.resourcePoolChanging = false;
                    }
                });
            };

            self.toggleRSTabs = function (tab) {

                self.tabs.forEach(function (item) {
                    item.active = false;
                });

                tab.active = true;

                setTabData();
            };

            self.selectPresentStaffTab = function () {

                if (!self.showPresentStaff) {
                    self.showPresentStaff = !self.showPresentStaff;
                }
            };

            self.toggleFilter = function () {
                self.showFilter = !self.showFilter;
            };

            self.showStaffScheduleDialog = function (staff) {

                if (staff.attendString && staff.attendString !== 'on') { return; }

                var data = {
                    personId: staff.personId,
                    personName: staff.staffName,
                    dateDisplayed: context.TopBar.dateDisplayed,
                    isCurrentDateDisplayed: context.TopBar.isCurrentDateDisplayed,
                    isPastDateDisplayed: context.TopBar.isPastDateDisplayed,
                    isFutureDateDisplayed: context.TopBar.isFutureDateDisplayed,
                    isLocked: !staff.canEdit,
                    activityStatuses: context.TopBar.activityStatuses,
                    reloadCallback: function () {
                        self.load();
                        context.CurrentView.load();
                    }
                };

                var popup = Utils.OpenModal('', 'ng1/src/dailyPlan/views/resourcePool/staffScheduleDialog.html', 'staffSchedulingController', data, 'daily-plan-staff-schedule-dialog', null, false);

                popup.result.then(function () {
                    popup.dismiss();
                });
            };

            self.borrowStaff = function (staff) {
                var msg = "Are you sure you want to borrow {0} into {1}?".format(staff.staffName, context.TopBar.BreadCrumbs.selectedViewType.unitName);

                var borrowActionCallback = function () { sendBorrowAction(staff, 0); };

                DailyPlanConfirmationService.BorrowAction(msg)
                                              .Yes(borrowActionCallback)
                                              .Ask();
            };

            self.undoBorrowStaff = function (staff) {

                var msg = "Are you sure you want to undo the borrow of {0} from {1}?".format(staff.staffName, context.TopBar.BreadCrumbs.selectedViewType.unitName);

                var borrowActionCallback = function () { sendBorrowAction(staff, 1); };

                DailyPlanConfirmationService.BorrowAction(msg)
                                              .Yes(borrowActionCallback)
                                              .Ask();
            };

            self.performFiltering = function () {

                var staff = self.Filter.filterStaff(unitStaff).filter(function (staff) {
                    return (staff.staffName ? staff.staffName.toLowerCase() : staff.staffName).indexOf(self.searchStaffName ? self.searchStaffName.toLowerCase() : self.searchStaffName) !== -1;

                });

                self.primaryStaffs = staff.filter(function (item) {
                    return item.areas.some(function (area) { return area === context.TopBar.BreadCrumbs.selectedLocation.id; }) ||
                           item.facilities.some(function (area) { return area === context.TopBar.BreadCrumbs.selectedLocation.id; });
                });

                self.otherUnitStaff = staff.filter(function (item) {
                    return !item.areas.some(function (area) { return area === context.TopBar.BreadCrumbs.selectedLocation.id; }) &&
                           !item.facilities.some(function (area) { return area === context.TopBar.BreadCrumbs.selectedLocation.id; });
                });

                self.tabs[0].count = self.primaryStaffs.filter(function (staff) { return staff.attendString === 'on'; }).length;
                self.tabs[1].count = self.otherUnitStaff.filter(function (staff) { return staff.attendString === 'on'; }).length;
                self.tabs[1].borrowCount = self.otherUnitStaff.filter(function (item) { return item.borrow; }).length;

                if (allUnitStaff) {

                    self.allUnitStaff = self.Filter.filterStaff(allUnitStaff).filter(function (staff) {
                        return staff.staffName.indexOf(self.searchStaffName) !== -1;
                    });

                    self.tabs[2].count = self.allUnitStaff.filter(function (staff) { return staff.attendString === 'on'; }).length;
                }

                setTabData();
            };

            self.orderPresentStaff = function (newOrderByField) {
                if (newOrderByField !== self.presentStaffOrderByField) {
                    self.presentStaffReverseOrdering = false;
                } else {
                    self.presentStaffReverseOrdering = !self.presentStaffReverseOrdering;
                }

                self.presentStaffOrderByField = newOrderByField;
            };

            self.clearFilter = function (filter) {
                filter.clear();
                if (filter.clearStaffSkillsFilter) {
                    self.Filter.StaffSkillsFilter.clear();
                }
                self.performFiltering();
            };

            self.clearAllFilters = function () {
                self.Filter.clearAllFilters();
                self.performFiltering();
            };

            self.revertFilters = function () {
                self.Filter.revertFilters();
                self.performFiltering();
            };

            self.changeShiftStart = function (staff) {

                var popup = Utils.OpenModal('', 'ng1/src/dailyPlan/views/dialogs/changeShiftStartDialog.html', 'ChangeShiftStartController', { startTime: staff.newStartTime || staff.shiftStartTime }, 'daily-plan-start-time-dialog');

                popup.result.then(function (data) {

                    if (moment(data.time, 'HH:mm a').isSame(moment(staff.shiftStartTime, 'HH:mm a'))) {
                        self.revertShiftStart(staff);
                        return;
                    }

                    var requestData = {
                        actionType: 1,
                        personId: staff.personId,
                        date: context.TopBar.dateDisplayed,
                        newStartTime: data.time
                    };

                    var loading = FlashService.Loading();

                    DailyPlanService.SetShiftStartTime(requestData).then(function (result) {
                        if (result.success) {

                            staff.newStartTime = requestData.newStartTime;
                            staff.newEndTime = moment(requestData.newStartTime, 'HH:mm a').add(staff.capacity || 0 + staff.overtime || 0, 'hours').format('hh:mm A');
                            staff.shiftLabel = '{0} - {1}*'.format(staff.newStartTime, staff.newEndTime);
                            staff.showEditShiftAction = false;

                            FlashService.Success('{0}\'s start time changed from {1} to {2}.'.format(staff.staffName, staff.shiftStartTime, staff.newStartTime));

                            loading.dismiss();
                        }
                    });
                });


            };

            self.revertShiftStart = function (staff) {

                var data = {
                    actionType: 0,
                    personId: staff.personId,
                    date: context.TopBar.dateDisplayed
                };

                var loading = FlashService.Loading();

                DailyPlanService.SetShiftStartTime(data).then(function (result) {
                    if (result.success) {

                        var msg = '{0}\'s start time reverted from {1} back to {2}.'.format(staff.staffName, staff.newStartTime, staff.shiftStartTime);

                        staff.newStartTime = null;
                        staff.newEndTime = null;
                        staff.shiftLabel = '{0} - {1}'.format(staff.shiftStartTime, staff.shiftEndTime);
                        staff.showEditShiftAction = true;

                        FlashService.Success(msg);

                        loading.dismiss();
                    }
                });
            };

            function processStaffTime(staff) {
                staff.shiftStartTime = CommonHelper.Time.GetFormattedAMPMTime(staff.shiftStartTime);
                staff.newStartTime = CommonHelper.Time.GetFormattedAMPMTime(staff.newStartTime);
                staff.shiftEndTime = CommonHelper.Time.GetFormattedAMPMTime(staff.shiftEndTime);
                staff.newEndTime = CommonHelper.Time.GetFormattedAMPMTime(staff.newEndTime);
            }

            function sendBorrowAction(staff, type) {                
                var data = {
                    borrowAction: type,
                    sourceUnitId: self.selectedUnit.id,
                    unitId: context.TopBar.BreadCrumbs.selectedViewType.id,
                    personId: staff.personId,
                    staffAreas: staff.staffAreas,
                    dateDisplayed: context.TopBar.dateDisplayed,
                    updateScenarioData: moment(context.TopBar.dateDisplayed).isAfter(moment())
                };

                self.resourcePoolChanging = true;

                DailyPlanService.BorrowAction(data).then(function (result) {

                    if (result.success) {
                        var successMsg = '';

                        if (!staff.borrowlist) {
                            staff.borrowlist = [];
                        }

                        if (type === 0) {
                            successMsg = '{0} successfully borrowed into {1}.'.format(staff.staffName, context.TopBar.BreadCrumbs.selectedViewType.unitName);
                            if (self.selectedUnit.id !== context.TopBar.BreadCrumbs.selectedViewType.id) {
                                self.selectedUnit = context.TopBar.BreadCrumbs.selectedViewType;
                                self.toggleRSTabs(self.tabs[1]);
                            }
                        } else {
                            successMsg = '{0} successfully un-borrowed from {1}.'.format(staff.staffName, context.TopBar.BreadCrumbs.selectedViewType.unitName);
                        }

                        self.load();
                        context.CurrentView.load();

                        FlashService.Success(successMsg);
                    } else {
                        self.resourcePoolChanging = false;
                    }


                });
            }

            function proccesUnitStaff() {
                unitStaff.forEach(function (staff) {
                    processStaffTime(staff);

                    staff.allowedToDrag = staff.attendString === 'on';
                    staff.showEditShiftAction = !staff.newStartTime;
                    var startWorkTime = (staff.overtime > 0 && staff.newStartTime) ? staff.newStartTime : staff.shiftStartTime;
                    var endWorkTime = (staff.overtime > 0 && staff.newEndTime) ? staff.newEndTime : staff.shiftEndTime;
                    staff.shiftLabel = staff.attendString === 'on' ? '{0} - {1}{2}'.format(startWorkTime, endWorkTime, staff.overtime > 0 ? '*' : '') : '';
                });
            }

            function proccesAllUnitStaff() {
                allUnitStaff.forEach(function (staff) {
                    processStaffTime(staff);

                    staff.allowedToDrag = false;
                    staff.showBorrowAction = true;
                    staff.showEditShiftAction = !staff.newStartTime;
                    var startWorkTime = (staff.overtime > 0 && staff.newStartTime) ? staff.newStartTime : staff.shiftStartTime;
                    var endWorkTime = (staff.overtime > 0 && staff.newEndTime) ? staff.newEndTime : staff.shiftEndTime;
                    staff.shiftLabel = staff.attendString === 'on' ? '{0} - {1}{2}'.format(startWorkTime, endWorkTime, staff.overtime > 0 ? '*' : '') : '';
                });
            }

            function setTabData() {
                var activeTab = self.tabs.filter(function (tab) { return tab.active; })[0] || self.tabs[0];

                switch (activeTab.id) {
                    case 0:
                        self.activeTabData = self.primaryStaffs;
                        break;
                    case 1:
                        self.activeTabData = self.otherUnitStaff;
                        break;
                    case 2:
                        self.activeTabData = self.allUnitStaff;
                        break;
                }

                self.activeTabMsg = activeTab.msg;

            }

            function initialize() {
                self.showPresentStaff = true;
                self.dndTarget = [];
                self.searchStaffName = '';
                self.Filter = new DailyPlanResourcePoolFilter(context);
                self.presentStaffOrderByField = 'staffName';
                self.presentStaffReverseOrdering = false;
            }

            initialize();
        }

        return (DailyPlanResourcePool);

    }]);
